import { RecipientsState }  from '../../reduxTypes';
import {
    RecipientSuccessAction,
    RecipientErrorAction
}                           from './RecipientActions';
import { Reducer, Action }  from 'redux';
import ActionTypes          from '../../ActionTypes';

export const defaultState: RecipientsState = {
    recipients: {}
};

const RecipientsReducer: Reducer<RecipientsState> = (state: RecipientsState = defaultState, action: Action): RecipientsState => {
    switch (action.type) {
        case ActionTypes.RECIPIENT_LOADING:
            return {
                ...state,
                loading: true
            };

        case ActionTypes.RECIPIENT_LOAD_ERROR:
            return {
                ...state,
                loading: false,
                error: (action as RecipientErrorAction).error
            };

        case ActionTypes.RECIPIENT_LOADED:
            return {
                ...state,
                loading: false,
                recipients: {
                    ...state.recipients,
                    [`recipient_${(action as RecipientSuccessAction).conversationId}`]: (action as RecipientSuccessAction).recipient
                }
            };

        default:
            return state;
    }
};

export default RecipientsReducer;



// WEBPACK FOOTER //
// ./src/sections/Recipient/RecipientsReducer.ts